// Re-export all domain-service API functions using wildcard imports
import * as commonApi from '@/api/domain-service/generated/common/common';
import * as conditionApi from '@/api/domain-service/generated/condition/condition';
import * as damageApi from '@/api/domain-service/generated/damage/damage';
import * as structureApi from '@/api/domain-service/generated/structure/structure';

// Re-export types
export * from '@/api/domain-service/generated/model';

// Re-export all API functions
export * from '@/api/domain-service/generated/common/common';
export * from '@/api/domain-service/generated/condition/condition';
export * from '@/api/domain-service/generated/damage/damage';
export * from '@/api/domain-service/generated/structure/structure';

// Enhanced function that returns all API functions
export function useDomainServiceApi() {
  function useCommonApi() {
    return commonApi;
  }

  function useConditionApi() {
    return conditionApi;
  }

  function useDamageApi() {
    return damageApi;
  }

  function useStructureApi() {
    return structureApi;
  }

  return {
    useCommonApi,
    useConditionApi,
    useDamageApi,
    useStructureApi,
  };
}
